import { render } from "./AppAccount.vue?vue&type=template&id=9af562e4"
import script from "./AppAccount.vue?vue&type=script&lang=js"
export * from "./AppAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__